import { render, staticRenderFns } from "./scenic.vue?vue&type=template&id=7072e0b7&scoped=true&"
import script from "./scenic.vue?vue&type=script&lang=ts&"
export * from "./scenic.vue?vue&type=script&lang=ts&"
import style0 from "./scenic.vue?vue&type=style&index=0&id=7072e0b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072e0b7",
  null
  
)

export default component.exports